import React from 'react';
import '../styles/pages/PolicyPage.css';

function PrivacyPolicyPage() {
  return (
    <div className="policy-page">
      <div className="policy-page__container">
        <header className="policy-page__header">
          <h1 className="policy-page__title">셀프애드 개인정보 처리방침</h1>
          <p className="policy-page__date">최종 수정일: 2026년 2월 4일</p>
        </header>

        <div className="policy-page__intro">
          <p>(주)카보(이하 "회사")는 「개인정보 보호법」 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이 개인정보 처리방침을 수립·공개합니다.</p>
        </div>

        {/* 목차 */}
        <nav className="policy-page__toc">
          <h2 className="policy-page__toc-title">목차</h2>
          <ul className="policy-page__toc-list">
            <li><a href="#article-1">제1조 (개인정보의 처리 목적)</a></li>
            <li><a href="#article-2">제2조 (처리하는 개인정보의 항목)</a></li>
            <li><a href="#article-3">제3조 (개인정보의 처리 및 보유 기간)</a></li>
            <li><a href="#article-4">제4조 (개인정보의 제3자 제공)</a></li>
            <li><a href="#article-5">제5조 (개인정보처리의 위탁)</a></li>
            <li><a href="#article-6">제6조 (정보주체의 권리·의무 및 그 행사방법)</a></li>
            <li><a href="#article-7">제7조 (개인정보의 파기)</a></li>
            <li><a href="#article-8">제8조 (개인정보의 안전성 확보 조치)</a></li>
            <li><a href="#article-9">제9조 (개인정보 보호책임자)</a></li>
            <li><a href="#article-10">제10조 (개인정보 처리방침 변경)</a></li>
          </ul>
        </nav>

        {/* 본문 */}
        <div className="policy-page__content">
          <section id="article-1" className="policy-page__section">
            <h2 className="policy-page__section-title">제1조 (개인정보의 처리 목적)</h2>
            <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>
            <ol className="policy-page__list">
              <li>
                <strong>회원가입 및 관리</strong>
                <p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지 목적으로 개인정보를 처리합니다.</p>
              </li>
              <li>
                <strong>서비스 제공</strong>
                <p>인플루언서 마케팅 중개 서비스 제공, 계약서 작성, 광고비 정산, 본인인증, 요금결제·정산을 목적으로 개인정보를 처리합니다.</p>
              </li>
              <li>
                <strong>고충처리</strong>
                <p>민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락·통지, 처리결과 통보 목적으로 개인정보를 처리합니다.</p>
              </li>
            </ol>
          </section>

          <section id="article-2" className="policy-page__section">
            <h2 className="policy-page__section-title">제2조 (처리하는 개인정보의 항목)</h2>
            <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>
            <ol className="policy-page__list">
              <li>
                <strong>공통 (인플루언서/광고주)</strong>
                <ul className="policy-page__sublist">
                  <li>필수항목: 이름, 이메일, 비밀번호, 휴대전화번호</li>
                  <li>선택항목: 마케팅 수신 동의 여부</li>
                </ul>
              </li>
              <li>
                <strong>인플루언서 추가 수집 항목</strong>
                <ul className="policy-page__sublist">
                  <li>필수항목: SNS 계정 정보(인스타그램, 유튜브 등), 팔로워 수, 계좌정보(정산용)</li>
                </ul>
              </li>
              <li>
                <strong>광고주 유형별 추가 수집 항목</strong>
                <ul className="policy-page__sublist">
                  <li>법인 유형: 회사명, 사업자등록번호, 대표자명, 사업장 주소, 담당자 정보</li>
                  <li>개인사업자 유형: 상호명, 사업자등록번호, 대표자명, 사업장 주소</li>
                  <li>프리랜서 유형: 이름, 연락처</li>
                </ul>
              </li>
              <li>
                <strong>결제 정보</strong>
                <ul className="policy-page__sublist">
                  <li>결제수단 정보(결제 시 입력하는 정보)</li>
                </ul>
              </li>
              <li>
                <strong>자동 수집 항목</strong>
                <ul className="policy-page__sublist">
                  <li>IP주소, 쿠키, 서비스 이용 기록, 접속 로그, 기기 정보</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-3" className="policy-page__section">
            <h2 className="policy-page__section-title">제3조 (개인정보의 처리 및 보유 기간)</h2>
            <ol className="policy-page__list">
              <li>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</li>
              <li>각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
                <ul className="policy-page__sublist">
                  <li>회원가입 및 관리: 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지)</li>
                  <li>계약·청약철회 등에 관한 기록: 5년</li>
                  <li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
                  <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
                  <li>표시·광고에 관한 기록: 6개월</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-4" className="policy-page__section">
            <h2 className="policy-page__section-title">제4조 (개인정보의 제3자 제공)</h2>
            <p>회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
            <p>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
            <ol className="policy-page__list">
              <li>
                <strong>결제 서비스 제공</strong>
                <ul className="policy-page__sublist">
                  <li>제공받는 자: 포트원(PortOne), PG사(KG이니시스 등)</li>
                  <li>제공 목적: 결제 처리</li>
                  <li>제공 항목: 이름, 휴대전화번호, 결제 정보</li>
                  <li>보유 및 이용 기간: 거래 종료 후 5년</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-5" className="policy-page__section">
            <h2 className="policy-page__section-title">제5조 (개인정보처리의 위탁)</h2>
            <p>회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.</p>
            <ol className="policy-page__list">
              <li>
                <strong>Amazon Web Services(AWS)</strong>
                <p>위탁업무 내용: 클라우드 서비스 제공(데이터 보관)</p>
              </li>
              <li>
                <strong>MongoDB Atlas</strong>
                <p>위탁업무 내용: 데이터베이스 서비스 제공</p>
              </li>
              <li>
                <strong>AWS CloudFront / S3</strong>
                <p>위탁업무 내용: 이미지 및 파일 저장·제공</p>
              </li>
            </ol>
            <p>회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p>
          </section>

          <section id="article-6" className="policy-page__section">
            <h2 className="policy-page__section-title">제6조 (정보주체의 권리·의무 및 그 행사방법)</h2>
            <ol className="policy-page__list">
              <li>정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
                <ul className="policy-page__sublist">
                  <li>개인정보 열람요구</li>
                  <li>오류 등이 있을 경우 정정 요구</li>
                  <li>삭제요구</li>
                  <li>처리정지 요구</li>
                </ul>
              </li>
              <li>권리 행사는 회사에 대해 「개인정보 보호법」 시행규칙 별지 제8호 서식에 따라 서면, 전자우편 등을 통하여 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.</li>
            </ol>
          </section>

          <section id="article-7" className="policy-page__section">
            <h2 className="policy-page__section-title">제7조 (개인정보의 파기)</h2>
            <ol className="policy-page__list">
              <li>회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</li>
              <li>파기의 절차 및 방법은 다음과 같습니다.
                <ul className="policy-page__sublist">
                  <li>파기절차: 불필요한 개인정보는 개인정보 보호책임자의 승인 하에 파기합니다.</li>
                  <li>파기방법: 전자적 파일 형태의 정보는 복구가 불가능한 방법으로 영구 삭제하고, 종이 문서는 분쇄기로 분쇄하거나 소각합니다.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section id="article-8" className="policy-page__section">
            <h2 className="policy-page__section-title">제8조 (개인정보의 안전성 확보 조치)</h2>
            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>
            <ol className="policy-page__list">
              <li>관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</li>
              <li>기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화, 보안프로그램 설치</li>
              <li>물리적 조치: 전산실, 자료보관실 등의 접근통제</li>
            </ol>
          </section>

          <section id="article-9" className="policy-page__section">
            <h2 className="policy-page__section-title">제9조 (개인정보 보호책임자)</h2>
            <p>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.</p>
            <div className="policy-page__highlight-box">
              <h3>▶ 개인정보 보호책임자</h3>
              <ul className="policy-page__plain-list">
                <li><strong>성명:</strong> 이동진</li>
                <li><strong>직책:</strong> 대표이사</li>
                <li><strong>연락처:</strong> 044-715-7442, ldjs35@daum.net</li>
              </ul>
            </div>
          </section>

          <section id="article-10" className="policy-page__section">
            <h2 className="policy-page__section-title">제10조 (개인정보 처리방침 변경)</h2>
            <p>이 개인정보처리방침은 2026년 2월 4일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 30일 전부터 공지사항을 통하여 고지할 것입니다.</p>
          </section>
        </div>

        {/* 사업자 정보 */}
        <footer className="policy-page__business-info">
          <h2 className="policy-page__business-info-title">사업자 정보</h2>
          <div className="policy-page__business-info-content">
            <p><strong>상호명:</strong> (주)카보</p>
            <p><strong>사업자등록번호:</strong> 291-86-02840</p>
            <p><strong>대표자:</strong> 이동진</p>
            <p><strong>주소:</strong> 충청남도 계룡시 장안1길 6, 202호</p>
            <p><strong>개인정보보호책임자:</strong> 이동진</p>
            <p><strong>전화번호:</strong> 044-715-7442</p>
            <p><strong>이메일:</strong> ldjs35@daum.net</p>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
